export const API_URL = 'https://app.whal3s.xyz/api/v0/';
// export const API_URL = 'http://127.0.0.1:8000/api/v0/';

export const ETH_MAINNET_RPC =
  'https://eth-mainnet.g.alchemy.com/v2/0CD8wxEZV2mm-62-K1n-1b6lwb8J-0Vh';
export const ETH_GOERLI_RPC =
  'https://eth-goerli.g.alchemy.com/v2/TijWHAm4zYTPpHAdX5Iwvy5FfurbMj7e';
export const MATIC_MUMBAI_RPC =
  'https://polygon-mumbai.g.alchemy.com/v2/N1p19q1m7-2BEiXFcnHaoqC5sOBIdAt8';
export const MATIC_MAINNET_RPC =
  'https://polygon-mainnet.g.alchemy.com/v2/e33U0gSrbTGtHynrubttLeAJlFc591Td';

export default {
  API_URL,
  ETH_MAINNET_RPC,
  ETH_GOERLI_RPC,
  MATIC_MUMBAI_RPC,
  MATIC_MAINNET_RPC
};
